require("./bootstrap");

import Vue from "vue";
window.Vue = require("vue");

import router from "./routes";
import store from "./store";
import VueSweetalert2 from "vue-sweetalert2";
import Vuex from "vuex";
import vueDebounce from "vue-debounce";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import vSelect from "vue-select";
import VueEditor from "vue2-editor";

Vue.use(VueEditor);

import draggable from "vuedraggable";
Vue.component("v-select", vSelect);
Vue.component("app", require("./components/AppComponent.vue").default);
Vue.component("list-vue", require("./components/ListVueComponent.vue").default);
Vue.component(
    "forms-vue",
    require("./components/FormVueComponent.vue").default
);
Vue.component(
    "forms-vue-crear",
    require("./components/FormVueComponentCrearRegistros.vue").default
);
// Vue.component(
//     "forms-vue-crear-multiple",
//     require("./components/FormVueComponentCrearRegistrosMultiple.vue").default
// );
Vue.component(
    "forms-vue-crear-tabla",
    require("./components/FormVueComponentCrearRegistrosTabla.vue").default
);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(draggable);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.use(Vuex);
Vue.use(VueSweetalert2);
Vue.use(vueDebounce);
const app = new Vue({
    el: "#app",
    store: store,
    router: router,
    data() {
        return {
            user: {},
            urlBase: process.env.MIX_APP_URL,
            baseRoute: process.env.MIX_APP_BASE_ROUTE,
        };
    },
    created() {
        console.log(process.env);
    },
    mounted() {},
    methods: {
        trans($texto) {
            //definir una forma de traduccion, se sugiere cargar un array con todas las traducciones, un solo archivo para cada idioma/
            return $texto;
        },
        UrlBase(path, base = false) {
            let url = "";

            if (this.urlBase) {
                url = this.urlBase + "/" + path;
            } else {
                url = "/" + path;
            }

            if (base) {
                url = this.baseRoute + url;
            }

            return url;
        },
        logout: function () {
            axios.post(this.UrlBase("logout")).then((response) => {
                location.reload();
            });
        },
        processValidation: function (error, redireccion) {
            var content = document.createElement("div");
            var mensaje = "";
            if (error.response && error.response.data.errors) {
                for (var o in error.response.data.errors) {
                    $.each(
                        error.response.data.errors[o],
                        function (index, value) {
                            mensaje += value + "<br>";
                        }
                    );
                }
            } else if (error.response) {
                mensaje = error.response.data.message;
                if (
                    typeof error.response.data.devolver != "undefined" &&
                    error.response.data.devolver == true
                ) {
                    if (redireccion) {
                        if (window.history.length > 2) {
                            router.go(-1);
                        } else {
                            router.push("/");
                        }
                    }
                }
            } else if (
                error.message !=
                "Cannot read properties of undefined (reading 'protocol')"
            ) {
                console.log(error);
                mensaje = error.message;
            }

            if (mensaje != "") {
                content.innerHTML = mensaje;
                toastr.error(content);
            }
        },
        async Consulta(
            ruta,
            data,
            verbo,
            validar,
            toastrAlert = false,
            cargando = false,
            alto_cargando = "initial",
            deshabilitarImputs = true,
            redireccion = true,
            mensaje_validador = false,
            responseType = "json"
        ) {
            var resultadoValidar = false;
            if (validar) {
                await this.$swal
                    .fire({
                        title: "Esta seguro?",
                        text: mensaje_validador
                            ? mensaje_validador
                            : "Esta acción no es reversible!",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Si!",
                        cancelButtonText: "Cancelar",
                    })
                    .then((result) => {
                        if (result.isDenied || result.isDismissed) {
                            resultadoValidar = false;
                        } else {
                            resultadoValidar = true;
                        }
                    });
            }

            var resultado = "";
            //llamada axios segun el verbo (laravel no toma put por ende se manda un post con un _method put)
            if (resultadoValidar == true || validar == false) {
                if (verbo == "put") {
                    data.append("_method", "put");
                }
                if (deshabilitarImputs) {
                    $("textarea").prop("disabled", true);
                    $("select").prop("disabled", true);
                    $("input").prop("disabled", true);
                    $("button").prop("disabled", true);
                }
                const config = {
                    headers: {
                        // 'Content-Type': `multipart/form-data;`,
                    },
                    responseType: responseType,
                };

                if (cargando != false) {
                    $(cargando).css("opacity", "0.5");
                    $(cargando).css("height", alto_cargando);
                    $(cargando).css("position", "relative");
                    $(cargando).append('<div class="overlay-easy"></div>');
                    $(".overlay-easy").css("position", "absolute");
                    // $('.overlay-easy').css('background-image','url(\'/img/loading.gif\')');
                    $(".overlay-easy").css("background-repeat", "no-repeat");
                    $(".overlay-easy").css("background-position", "center");
                    $(".overlay-easy").css("background-size", "100px");
                    $(".overlay-easy").css("top", "0px");
                    $(".overlay-easy").css("bottom", "0px");
                    $(".overlay-easy").css("left", "0px");
                    $(".overlay-easy").css("right", "0px");
                    $(".overlay-easy").css("z-index", "99999");
                }
                return await (verbo == "post"
                    ? axios.post
                    : verbo == "put"
                    ? axios.post
                    : verbo == "delete"
                    ? axios.delete
                    : verbo == "get"
                    ? axios.get
                    : axios.post)(ruta, data, config)
                    .then((response) => {
                        if (toastrAlert) {
                            toastr.success(response.data.message);
                        }
                        resultado = response.data;
                    })
                    .catch((error) => {
                        console.log(error);
                        resultado = false;
                        this.$root.processValidation(error, redireccion);
                    })
                    .then(function () {
                        if (cargando != false) {
                            $(cargando).css("opacity", "1");
                            $(cargando).css("height", "initial");
                        }
                        $(".overlay-easy").remove();
                        if (deshabilitarImputs) {
                            $("textarea").prop("disabled", false);
                            $("select").prop("disabled", false);
                            $("input").prop("disabled", false);
                            $("button").prop("disabled", false);
                        }
                        return resultado;
                    });
            } else {
                return false;
            }
        },
    },
});
